import React, { ChangeEvent, FunctionComponent } from 'react';
import { CompaniesModal } from '../../atoms/companiesModal';
import type { Props as ComponentProps } from './types';

type Props = ComponentProps & {
  companyName: string;
  tmpCompanyName: string;
  isModalOpen: boolean;
  tmpSelectedIndustries: string[];

  handleInputClick: () => void;
  handleCloseModal: () => void;
  handleInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleIndustryChange: (industryId: number) => void;
  handleClear: () => void;
  handleSearch: () => void;
};

export const Presentation: FunctionComponent<Props> = (props) => {
  return (
    <>
      <div className="company-search-form">
        <div className={'company-search-form__wrapper'} onClick={props.handleInputClick}>
          {props.companyName ? (
            <div className="value">{props.companyName}</div>
          ) : (
            <div className="placeholder">
              <span className="material-symbols-outlined">search</span>
              会社を検索する
            </div>
          )}
        </div>
      </div>
      <CompaniesModal
        isOpen={props.isModalOpen}
        onClose={props.handleCloseModal}
        companyName={props.tmpCompanyName}
        selectedIndustries={props.tmpSelectedIndustries}
        onCompanyNameChange={props.handleInputChange}
        onIndustryChange={props.handleIndustryChange}
        onClear={props.handleClear}
        onSearch={props.handleSearch}
        filteredCompaniesCount={props.filteredCompaniesCount}
        totalCount={props.totalCount}
        industries={props.industries}
        showIndustryFilter={props.showIndustryFilter}
        loading={props.loading}
      />
    </>
  );
};
